import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=51dceaca&scoped=true"
import script from "./UserDisplay.vue?vue&type=script&lang=js"
export * from "./UserDisplay.vue?vue&type=script&lang=js"
import style0 from "./UserDisplay.vue?vue&type=style&index=0&id=51dceaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dceaca",
  null
  
)

export default component.exports